//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { ColumnModel } from './../api/api.models'

import { CreateEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { IUserSession } from "../../helpers/user-session"
import { LocalizationHelper } from '../../helpers/localization-helper'

import { Enums } from '../../models/common/enums'
import { IReferenceType, IOpObject } from '../../models/util/interfaces'
import { OpChangeState } from '../../models/common/enums'
import { OpLocation } from '../../models/core/op-location'
import { SESSION } from '../../models/custom/session'
import { ItemSwapperPopupOptions, IItemSwapperPopup, ItemSwapperResult } from '../../modules/common/item-swapper/'

/** 
deprecated - Use service instead
**/
export class GroupingLocationHelper {

    // #region Consts

    public static get FILE_NAME_PREFIX(): string { return 'grouping-locations' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType  { return Enums.ReferenceType.IdLocation }  
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName  { return Enums.SimaxModuleName.Grouping_Location }

    // #endregion


    // #region Methods

    public static deleteGroupingLocation(dataProvider: DataProvider, idLocation: number): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()
        const toDelete: OpLocation = new OpLocation(null)

        toDelete.idLocation = idLocation

        dataProvider.Location
            .deleteLocation(toDelete)
            .then(() => {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, GroupingLocationHelper.SIMAX_MODULE_NAME))
                deferred.resolve()
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                    CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
                } else {
                    CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETE_ERROR, GroupingLocationHelper.SIMAX_MODULE_NAME), 'error', 4000)
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static saveAssignedLocations(dataProvider: DataProvider, parentLocationId: number, swapResult: ItemSwapperResult<OpLocation>): JQueryPromise<OpLocation> {

        let promise: JQueryPromise<any> = $.Deferred().resolve().promise()

        const addLocationAction: (added: OpLocation) => JQueryPromise<OpLocation> = (added: OpLocation) => {
            const childLocation: OpLocation = new OpLocation(null)
            const parentLocation: OpLocation = new OpLocation(null)

            parentLocation.idLocation = parentLocationId
            parentLocation.opState = OpChangeState.New

            childLocation.idLocation = added.idLocation
            childLocation.opState = OpChangeState.Modified

            childLocation.parentGroups.push(parentLocation)

            return dataProvider.Location.saveLocation(childLocation)
        }

        const removeLocationAction: (removed: OpLocation) => JQueryPromise<OpLocation> = (removed: OpLocation) => {
            const childLocation: OpLocation = new OpLocation(null)
            const parentLocation: OpLocation = new OpLocation(null)

            parentLocation.idLocation = parentLocationId
            parentLocation.opState = OpChangeState.Delete

            childLocation.idLocation = removed.idLocation
            childLocation.opState = OpChangeState.Modified

            childLocation.parentGroups.push(parentLocation)

            return dataProvider.Location.saveLocation(childLocation)
        }

        swapResult.addedToLeft.forEach((added: OpLocation) => {
            promise = promise.then(() => addLocationAction(added))
        })

        swapResult.addedToRight.forEach((removed: OpLocation) => {
            promise = promise.then(() => removeLocationAction(removed))
        })

        return promise.then((location: OpLocation) => {
            CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, GroupingLocationHelper.SIMAX_MODULE_NAME))
            return null
        })
        .fail((error: any) => {
            let errorMsg: string = error

            if (SESSION.isType(error)) {
                errorMsg = (<SESSION>error).toString()
                CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
            } else {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVE_ERROR, GroupingLocationHelper.SIMAX_MODULE_NAME), 'error', 4000)
            }

            return errorMsg
        })
    }

    public static saveGroupingLocation(dataProvider: DataProvider, location: OpLocation): JQueryPromise<OpLocation> {
        const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

        dataProvider.Location
            .saveLocation(location)
            .then((savedObject: OpLocation) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static getDefaultAssignedLocationsItemSwapperOptions(
        dataProvider: DataProvider, 
        moduleName: Enums.SimaxModuleName, 
        referenceType: Enums.ReferenceType, 
        idGroupingLocation: number = null
    ): JQueryPromise<ItemSwapperPopupOptions<OpLocation>> {
        return dataProvider.System
            .getRequestColumnInfo(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ASSIGNED_LOCATION_GRID_PARAMS,
                moduleName
            )
            .then((columns: ColumnModel[]): ItemSwapperPopupOptions<OpLocation> => {
                return {
                    referenceType,

                    itemSwapperOptions: {
                        rightGridOptions: {
                            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AvailableLocations),

                            dataBag: true,

                            columnsDictionary: columns,

                            getDataSourceFilter: dataProvider.Location.getAllLocationFilter
                        },

                        leftGridOptions: {
                            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedLocations),

                            columnsDictionary: columns,

                            getDataSource: () => dataProvider.GroupingLocation.getGroupingLocationAssignedLocations(idGroupingLocation)
                        }
                    },

                    onInitialized: (itemSwapper: IItemSwapperPopup<OpLocation>) => {
                        return itemSwapper
                    },

                    itemSwapperPopupTitle:  LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedLocations)
                }
            })
    }

    // #endregion


    // #region Options

    public static getCreateEditOptions(userSession: IUserSession, referenceObjectId: number = 0, referenceObject: IReferenceType & IOpObject = null): CreateEditInitParams {
        return {
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: Enums.ReferenceType.IdDistributor,
            groupReferenceValue: userSession.getLoggedOperator().idDistributor,
            idReferenceType: GroupingLocationHelper.REFERENCE_TYPE,
            moduleName: GroupingLocationHelper.SIMAX_MODULE_NAME,
            sections: null,
            useBusinessObjects: true,

            referenceObject,
            referenceObjectId,
        }
    }

    // #endregion
}
